import React from "react";
import '../styles/questionAdhd.css';

function QuestionAutism({ question, onAnswer, index }) {
    const handleChange = (event) => {
        const points = parseInt(event.target.value, 10);
        onAnswer(question, points, index);
    };
    const options = ["Aldrig stämt", "Stämmer bara nu", "Stämmer bara på hur jag var före 16 års ålder", "Stämmer nu och när jag var ung"];

return (
    <div className="question">
        <p>{question}</p>
        <div className="radio-container mobile-flex">
            {options.map((option, index) => {
                const id = `${question.replace(/\s+/g, "-")}-${index}`;
                return (
                    <div key={id} className="radio-option mobile">
                        <input
                            type="radio"
                            id={id}
                            name={question}
                            value={index}
                            className="radio-input"
                            onChange={handleChange}
                        />
                        <label htmlFor={id} className="radio-label">
                            {option}
                        </label>
                    </div>
                );
            })}
        </div>
    </div>
);
};

export default QuestionAutism;